import React, { useState, useEffect } from 'react';

const PdfRadio = ({ page, inputId, value, onChange, options = [], name, place_holder }) => {
  const [selectedValue, setSelectedValue] = useState(value || false);

  // Sync internal state with parent value prop
  useEffect(() => {
    setSelectedValue(value || false);
  }, [value]);

  const handleRadioChange = (optionValue) => {
    setSelectedValue(optionValue);
    onChange(page, inputId, optionValue);
  };

  const handleSingleRadioChange = () => {
    const newValue = !selectedValue;
    setSelectedValue(newValue);
    onChange(page, inputId, newValue);
  };

  // Fallback: if no explicit name is provided, group radio buttons by page
  const radioGroupName = name || `radio-page-${page}`;

  return (
    <div className="pdf-radio">
      {options.length > 0 ? (
        options.map((option, index) => (
          <label key={index} className="pdf-radio-label">
            <input
              type="radio"
              name={radioGroupName}
              value={option.value || option}
              checked={selectedValue === (option.value || option)}
              onChange={() => handleRadioChange(option.value || option)}
              className="pdf-radio-input"
            />
            <span className="pdf-radio-text">{option.label || option}</span>
          </label>
        ))
      ) : (
        <input
          type="radio"
          name={radioGroupName}
          checked={selectedValue}
          onChange={handleSingleRadioChange}
          className="pdf-radio-input"
        />
      )}
    </div>
  );
};

export default PdfRadio;
